import { render, staticRenderFns } from "./VedioList.vue?vue&type=template&id=4203f3f6&scoped=true"
import script from "./VedioList.vue?vue&type=script&lang=js"
export * from "./VedioList.vue?vue&type=script&lang=js"
import style0 from "./VedioList.vue?vue&type=style&index=0&id=4203f3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203f3f6",
  null
  
)

export default component.exports